import Vue from 'vue'
import axios from 'axios';
import { getCookie } from '@/utils/utils'


axios.defaults.withCredentials = true // 若跨域请求需要带 cookie 身份识别
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded'

var instance = axios.create({
  // baseURL: '/api',
  timeout: 10000
});
// 添加请求拦截器
instance.interceptors.request.use( async function (config) {
  let Authorization = await getCookie('_t');
  config.headers['Authorization'] = window.sessionStorage.getItem('_t') || Authorization || '' ;
  return config;
}, function (error) {
  return Promise.reject(error);
});

// 添加响应拦截器
instance.interceptors.response.use(function (res) {
  return res.data;
}, function (error) {
  // 对响应错误做点什么
  // Message({
  //   message: '接口异常',
  //   type: 'error'
  // });
  return Promise.reject(error);
});

Vue.prototype.$http = instance;
window.$http = instance;
export { instance as $http }
